import React from 'react';
import { Link } from 'react-router-dom';
import './Button.css';

export default function Button ({
  children,
  variant  = 'primary',  // primary | secondary | gold | ghost
  size     = 'md',       // sm | md | lg
  href,                  // external link
  to,                    // internal route
  onClick,
  disabled = false,
  fullWidth = false,
  className = '',
  ...props
}) {
    const classes = [
        'btn',
        `btn--${variant}`,
        `btn--${size}`,
        fullWidth  ? 'btn--full'     : '',
        disabled   ? 'btn--disabled' : '',
        className,
    ].filter(Boolean).join(' ');

    // External link
    if (href) {
        return (
            <a
                href={href}
                className={classes}
                target="_blank"
                rel="noopener noreferrer"
                {...props}
            >
                {children}
            </a>
        );
    }

    // Internal route
    if (to) {
        return (
        <Link to={to} className={classes} {...props}>
            {children}
        </Link>
        );
    }

    // Regular button
    return (
        <button
            className={classes}
            onClick={onClick}
            disabled={disabled}
            {...props}
        >
            {children}
        </button>
    );
};